<!-- 工艺边框 -->
<template>
  <BaseFormItem
    class="sidewidth"
    :unit="hasDfmSets && dfmSidewidth ? '' : fields.unit"
    :label="fields.label"
    :labelTips="labelTips"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
  >
    <div v-if="hasDfmSets && dfmSidewidth">
      {{ dfmSidewidth }}
    </div>
    <template v-else>
      <BaseInput 
        v-model="val.sidewidth" 
        width="130px" 
        class="sidewidth__input"
        :disabled="disabledInput || disabled"
        @change="handleSidewidthChange"
      >
        <BaseSelect 
          slot="prepend"
          v-model="val.sidedirection" 
          width="60px"
          placeholder="请选择"
          :disabled="disabled"
          @change="handleSidedirectionChange"
        >
          <el-option
            v-for="item in fields.options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </BaseSelect>
      </BaseInput>
      <span slot="other" class="sidewidth__tips">
        <template v-if="isSmt">
          无工艺边可能会增加额外的治具费用
        </template>
        <template v-else>
          如需在华秋贴片，建议设置不小于5mm的工艺边框; 
          <span>无工艺边可能会增加额外的治具费用</span>
        </template>
      </span>
    </template>
  </BaseFormItem>
</template>

<script>
import { getFR4Fields } from '@@/utils/getFields'

export default {
  props: {
    sidedirection: {
      type: String,
      default: ''
    },
    sidewidth: {
      type: [Number, String],
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isSmt: {
      type: Boolean,
      default: false
    },
    // 是否有DFM传值json
    hasDfmSets: {
      type: Boolean,
      default: false
    },
    dfm_sets: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      val: {
        sidedirection: this.sidedirection,
        sidewidth: this.sidewidth
      },
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
    }
  },
  computed: {
    fields() {
      return getFR4Fields('sidewidth')
    },
    labelTips() {
      if (this.isSmt) {
        return `
          ①、工艺边常用尺寸为5MM。\n
          ②、华秋代拼加工艺边，会默认在工艺边上加定位孔及MARK点，以方便上机贴片。若文件设计有工艺边需要华秋添加MARK点、定位孔等请备注说明。
        `
      }
      return this.fields.labelTips
    },
    disabledInput() {
      return this.val.sidedirection === '无'
    },
    // 最小限制
    minLimit() {
      // PCBA下单最小为5
      return this.isSmt ? 5 : 3
    },
    // DFM传值的工艺边展示
    dfmSidewidth() {
      const dfm_sets = this.dfm_sets
      if (dfm_sets) {
        const dfmSets = JSON.parse(dfm_sets) || {}
        return `上：${dfmSets.side_width_top}mm、下：${dfmSets.side_width_bot}mm、左：${dfmSets.side_width_left}mm、右：${dfmSets.side_width_right}mm`
      }
      return ''
    }
  },
  watch: {
    sidedirection(sidedirection) {
      this.val.sidedirection = sidedirection
    },
    sidewidth(sidewidth) {
      this.val.sidewidth = sidewidth
    }
  },
  methods: {
    handleEmit(key) {
      this.$emit(`update:${key}`, this.val[key])
      this.isShowError(false)
    },
    handleEmitChange() {
      this.$emit('change', { ...this.val })
    },
    handleSidedirectionChange(val) {
      if (val == '无') {
        this.val.sidewidth = 0
        this.handleEmit('sidewidth')
      } else {
        // 首次选工艺边方向后，工艺边框初始值改为 5
        if (this.val.sidewidth == 0) {
          this.val.sidewidth = 5
          this.handleEmit('sidewidth')
        }
      }
      this.handleEmit('sidedirection')
    },
    handleSidewidthChange(val) {
      const minLimit = this.minLimit
      val = Number(val)
      if (this.val.sidedirection != '无') {
        if (val < minLimit) {
          this.$message.warning(`工艺边最少${minLimit}mm`)
          val = minLimit
        }
        if (val > 999) {
          this.$message.warning('工艺边最宽999mm')
          val = 5
        }
        if (val * 10 % 5 != 0) {
          this.$message.warning('工艺边框仅支持0.5的倍数，比如3.5, 4 , 4.5')
          val = Math.round(val * 2) / 2
        }
        this.val.sidewidth = val
      }
      this.handleEmit('sidewidth')
    },
    // 是否显示错误提示样式
    isShowError(isShow, isBlink = false) {
      this.isError = isShow
      this.isErrorBlink = isBlink
    }
  }
}
</script>

<style lang="scss" scoped>
.sidewidth ::v-deep {
  .sidewidth__input .el-input-group__prepend {
    background-color: #fff;
    cursor: pointer;
  }
  .el-input.is-disabled {
    .el-input__inner,
    .el-input__icon {
      cursor: pointer;
    }
    .el-input__inner[disabled] {
      cursor: not-allowed;
    }
  }
  .sidewidth__tips {
    font-size: 12px;
    color: $--color-warning;
    >span {
      color: $--color-text-placeholder;
    }
  }
}
</style>